<template>
  <div>
    <validation-observer ref="cancellationObserver" novalidate>
      <div class="px-4 py-1">
        <div class="mb-3 font-weight-bold">
          <i class="fas fa-info-circle text-orange mr-2"></i>
          Confirmar Transferencia
        </div>
      </div>
      <div class="px-4 font-weight-normal">
        <validation-provider
          class="w-100"
          name="Comentario"
          rules="required"
          v-slot="{ errors }"
        >
          <label>Fecha en que recibiste:</label>
          <custom-date-picker
            v-model="date"
            required
            placeholder="DD/MM/YYYY"
            class="cd"
            :min-date="minDate"
            :max-date="new Date()"
            :error="errors[0]"
            :custom-error-msg="'La fecha es requerida'"
          />
        </validation-provider>
      </div>

      <div class="d-flex justify-content-end align-items-center px-4 mt-4 pb-3">
        <action-button
          id="btnCancel"
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3 px-3"
          @click="handlerClose()"
        />
        <action-button
          id="btnSave"
          i="fas fa-save"
          text="Guardar"
          variant="success px-3"
          @click="cancelTransfer()"
        />
      </div>
    </validation-observer>
  </div>
</template>

<script>
import mixAlert from '@/mixins/alert.mixin';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import ActionButton from 'ActionButton';
import inventoryCatalogService from '@/services/api/inventorycatalog.api';
import CustomDatePicker from 'custom-date-picker';
import moment from 'moment';
export default {
  name: 'TransferCancellation',
  components: {
    CustomDatePicker,
    ValidationObserver,
    ValidationProvider,
    ActionButton,
  },
  mixins: [mixAlert],
  props: {
    transfer: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      date: null,
    };
  },
  computed: {
    minDate() {
      return moment(this.transfer.sendDate)
        .add(-1, 'days')
        .toDate();
    },
  },
  methods: {
    handlerClose() {
      this.$emit('close');
    },
    async cancelTransfer() {
      var isValid = await this.$refs.cancellationObserver.validate();
      if (!isValid) {
        return;
      }
      const isConfirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro que desea actualizar la solicitud?`,
        'Sí',
        'No'
      );

      if (!isConfirmed) {
        return;
      }
      var payload = {
        date: this.date,
      };

      inventoryCatalogService
        .confirmInventoryTransfer(this.transfer.id, payload)
        .then(() => {
          this.ShowToast(
            'Éxito',
            'La transferencia se ha confirmado exitosamente.',
            'success'
          );
          this.date = null;
          this.$emit('refresh');
        })
        .catch((error) => {
          this.ShowToast('Error', error?.response?.data.message, 'error');
        });
    },
  },
};
</script>
<style lang="scss"></style>
